import React from 'react';
import Header from '../Header';
import Sidebar from '../Sidebar';
import MapComponent from '../MapComponent';
import Alerts from '../Alerts';
import SosAlertBanner from '../SosAlertBanner/SosAlertBanner';
import BeachInfoPanel from '../BeachInfoPanel';
import AdminCommandPanel from '../AdminCommandPanel';

const MainLayout = ({
    user,
    handleLogout,
    handleNotificationClick,
    isBackendOnline,
    lastUpdateTime,
    isMobile,
    isSidebarOpen,
    toggleSidebar,
    activeFilters,
    handleFilterChange,
    filterOptions,
    handleRemoveFilter,
    showNameplates,
    toggleNameplates,
    showGeofences,
    toggleGeofences,
    isAdmin,
    openAdminPanel,
    filteredDevices,
    selectedDevice,
    handleDeviceClick,
    handleCloseDeviceInfo,
    ...mapProps
}) => {
    return (
        <div className="flex flex-col h-screen max-w-full m-0 overflow-hidden relative bg-white lg:bg-white">
            {/* Skip to content link for accessibility */}
            <a href="#map-container" className="sr-only focus:not-sr-only focus:absolute focus:top-2 focus:left-2 focus:z-[9999] focus:bg-white focus:px-4 focus:py-2 focus:rounded-lg focus:shadow-lg focus:text-primary focus:font-semibold">
                Skip to Map
            </a>
            <SosAlertBanner
                alert={(mapProps.alerts || []).find((a) => a.type === 'sos_emergency')}
                onDismiss={mapProps.closeSosFromAtlas || mapProps.dismissAlert}
                onLocate={mapProps.locateSosDevice}
            />
            <Alerts alerts={
                    mapProps.alerts
                }
                onDismiss={
                    mapProps.dismissAlert
                }
                onDismissAll={
                    mapProps.dismissAllAlerts
                }/>
            <BeachInfoPanel beachData={
                    mapProps.selectedBeachGeofence
                }
                onClose={
                    mapProps.closeBeachPanel
                }/>
            <Header user={user}
                onLogout={handleLogout}
                onNotificationClick={handleNotificationClick}
                isBackendOnline={isBackendOnline}
                lastUpdateTime={lastUpdateTime}
                isMobile={isMobile}
                isSidebarOpen={isSidebarOpen}/>
            <div className="flex flex-grow overflow-hidden w-full pt-16 lg:pt-20">
                <Sidebar isSidebarOpen={isSidebarOpen}
                    onLogout={handleLogout}
                    onNotificationClick={handleNotificationClick}
                    activeFilters={activeFilters}
                    onFilterChange={handleFilterChange}
                    filterOptions={filterOptions}
                    onRemoveFilter={handleRemoveFilter}
                    showNameplates={showNameplates}
                    onToggleNameplates={toggleNameplates}
                    showGeofences={showGeofences}
                    onToggleGeofences={toggleGeofences}
                    isAdmin={isAdmin}
                    onOpenAdminPanel={openAdminPanel}
                    filteredDevices={filteredDevices}
                    onDeviceClick={handleDeviceClick}
                    shouldNavigateToSelectedDevice={mapProps.shouldNavigateToSelectedDevice}
                    selectedCity={mapProps.selectedCity}
                    selectedState={mapProps.selectedState}
                    selectedCountry={mapProps.selectedCountry}
                    setSelectedCountry={mapProps.setSelectedCountry}
                    setIsBoundaryLoading={mapProps.setIsBoundaryLoading}
                    isBoundaryLoading={mapProps.isBoundaryLoading}
                    />
<main className="flex-1 relative" id="map-container" role="region" aria-label="Device tracking map">
                    <div className="w-full h-full lg:rounded-tr-xl lg:rounded-br-xl overflow-hidden">
                        <MapComponent {...mapProps}
                            showNameplates={showNameplates}
                            showGeofences={showGeofences}
                            selectedDevice={selectedDevice}/>
                    </div>
                </main>
            </div>
            {isSidebarOpen && (
              <div
                className="fixed top-0 left-0 w-full h-full bg-black/50 z-[999] lg:hidden"
                onClick={toggleSidebar}
                aria-label="Close sidebar overlay"
                role="button"
                tabIndex={0}
                onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggleSidebar(); } }}
              ></div>
            )}

            {
                !isSidebarOpen && (
                  <button
                    className="lg:hidden fixed top-[76px] left-4 z-[1001] bg-white border-none p-2.5 rounded-lg shadow-md cursor-pointer flex flex-col justify-around w-11 h-11"
                    onClick={toggleSidebar}
                    aria-label="Open sidebar"
                  >
                    <div className="w-full h-0.5 bg-gray-800 rounded transition-all duration-300"></div>
                    <div className="w-full h-0.5 bg-gray-800 rounded transition-all duration-300"></div>
                    <div className="w-full h-0.5 bg-gray-800 rounded transition-all duration-300"></div>
                  </button>
                )
            }
            {
            mapProps.isAdminPanelOpen && (
                <AdminCommandPanel onClose={
                    mapProps.closeAdminPanel
                }/>
            )
        }
            {/* ARIA live region for selected device announcements */}
            <div aria-live="polite" aria-atomic="true" className="sr-only">
                {selectedDevice && `Selected: ${selectedDevice.displayName || selectedDevice.name || selectedDevice.device_id}`}
            </div>
        </div>
    );
};

export default MainLayout;
